module.exports = __webpack_public_path__ + "static/media/project3.fee77697.png";